var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckCircle, Error, Info, Warning } from "@mui/icons-material";
import { Alert, Grid } from "@mui/material";
var severityIconMap = {
    success: _jsx(CheckCircle, {}),
    error: _jsx(Error, {}),
    info: _jsx(Info, {}),
    warning: _jsx(Warning, {}),
};
var AlertContainer = function (_a) {
    var _b;
    var message = _a.message, _c = _a.severity, severity = _c === void 0 ? "info" : _c;
    return (_jsx(Grid, __assign({ container: true }, { children: _jsx(Grid, __assign({ item: true, xs: 12, sx: { display: "flex", justifyContent: "center", mt: 5 } }, { children: _jsx(Alert, __assign({ icon: (_b = severityIconMap[severity]) !== null && _b !== void 0 ? _b : _jsx(Info, {}), severity: severity }, { children: message })) })) })));
};
export default AlertContainer;
